import React from 'react';
import PropTypes from 'prop-types';

import {
  DueMonthlyWrapper,
  DueMonthlyText,
  Amount,
  DueNowWrapper,
  DueNowText,
  ButtonsWrapper,
  Button,
  Flex,
  Title,
  ButtonContinue
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Desktop = ({
  isFormTouched,
  isFormValidated,
  isChannelTISales,
  isChannelSMBDigitalFr,
  isFirstStep,
  isLastStep,
  isOrderLastStep,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onBackClick,
  hidePricing,
  hideBackButton,
  isEligible,
  onCreateNewOrder,
  isCreateOrderVisible,
  disableContinue
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES },
    formButtons: {
      saveContinueLaterButtonLabel,
      continueButtonLabel,
      downloadTheQuoteLabel,
      backLabel,
      newOrderButtonLabel,
      submitButtonLabel
    }
  } = localizedStringsContext;
  return (
    <div id="footer-high">
      <DueMonthlyWrapper>
        {!hidePricing && (
          <>
            <DueMonthlyText>
              <span className="frg-body-font-14px color-white">
                {DUE_MONTHLY}
              </span>
              <Title>{BEFORE_TAXES}</Title>
            </DueMonthlyText>
            <Amount>
              <span className="frg-body-font-27px color-white">
                <div id="footer-monthly-total">{dueMonthly}</div>
              </span>
            </Amount>
          </>
        )}
      </DueMonthlyWrapper>
      <DueNowWrapper>
        {!hidePricing && (
          <>
            <DueNowText>
              <span className="frg-body-font-14px color-white">{DUE_NOW}</span>
              <Title>{BEFORE_TAXES}</Title>
            </DueNowText>
            <Amount>
              <span className="frg-body-font-27px color-white">
                <div id="footer-now-total">{dueNow}</div>
              </span>
            </Amount>
          </>
        )}
      </DueNowWrapper>

      <ButtonsWrapper>
        {(!isOrderLastStep && (
          <Flex>
            {isFormValidated &&
              isLastStep &&
              !isChannelTISales &&
              !isChannelSMBDigitalFr && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onDownloadClick(e)}
                    className="frg-button color-green"
                  >
                    <span>{downloadTheQuoteLabel}</span>
                  </button>
                </Button>
              )}
            {isFormValidated && isLastStep && isCreateOrderVisible && (
              <Button>
                <button
                  type="button"
                  onClick={e => onCreateNewOrder(e)}
                  className="frg-button color-purple"
                >
                  <span>{newOrderButtonLabel}</span>
                </button>
              </Button>
            )}
            {!isFormValidated && !isFirstStep && !hideBackButton && (
              <Button>
                <button
                  type="button"
                  onClick={e => onBackClick(e)}
                  className="frg-button color-green"
                >
                  <span>{backLabel}</span>
                </button>
              </Button>
            )}
            {!isFormValidated && !isLastStep && (
              <Button>
                <button
                  type="button"
                  onClick={e => onSaveAndExit(e)}
                  className="frg-button color-green"
                  disabled={!isFormTouched}
                >
                  <span>{saveContinueLaterButtonLabel}</span>
                </button>
              </Button>
            )}
            {!isFormValidated && (
              <ButtonContinue>
                <button
                  type="button"
                  disabled={!isEligible || (!disableContinue && isLastStep)}
                  onClick={e => onProceedClick(e)}
                  className="frg-button color-purple"
                >
                  <span>{continueButtonLabel}</span>
                </button>
              </ButtonContinue>
            )}
          </Flex>
        )) || (
          <Flex>
            <Button>
              <button
                type="button"
                onClick={e => onProceedClick(e)}
                className="frg-button color-purple"
              >
                <span>{submitButtonLabel}</span>
              </button>
            </Button>
          </Flex>
        )}
      </ButtonsWrapper>
    </div>
  );
};

Desktop.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isOrderLastStep: PropTypes.bool.isRequired,
  isChannelSMBDigitalFr: PropTypes.bool.isRequired,
  isChannelTISales: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  hideBackButton: PropTypes.bool.isRequired,
  isEligible: PropTypes.bool.isRequired,
  onCreateNewOrder: PropTypes.func.isRequired,
  isCreateOrderVisible: PropTypes.bool.isRequired,
  disableContinue: PropTypes.bool.isRequired
};

export default Desktop;
